import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { LoadingAndErrors } from '../../../../classes';
import { ProductsService, DiscountsService, OrderingService } from '../../../../services';
import { OrderApi } from '../../../../../assets/js/lb-sdk/services/custom/Order';
import { finalize, catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { LoopBackAuth, PaymentApi, LoopBackConfig } from '../../../../../assets/js/lb-sdk';
import { PAYMENT_METHOD, USER_ROLES, PAYMENT_TYPE } from '../../../../enums';
import { ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { Observable, of } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap';
import { HttpXsrfTokenExtractor } from '@angular/common/http';
import {FormControl, NgForm} from '@angular/forms';

import { OrdersService } from  '@app/services/v1/orders.service';
import { Order, CreditCard } from '@app/interfaces';

declare var jQuery: any;

interface PaymentForm {
  paymentMethod: number
};

interface paypalPaymentData {
  billingToken?: string; // null
  button_version: string; // "4.0.37"
  intent: string; // "sale"
  orderID: string; // "EC-32J10496LK475301R"
  payerID: string; // "56NZLTWTM7KWG"
  paymentID: string; // "PAYID-MIZHJ3A3D53051215769580D"
  paymentToken: string; // "EC-32J10496LK475301R"
  returnUrl: string; // "http://return.url/?paymentId=PAYID-MIZHJ3A3D53051215769580D&token=EC-32J10496LK475301R&PayerID=5
}

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: [
    './payment-form.component.css',
    '../order-form/order-form.component.css'
  ],
  providers: [DecimalPipe]
})
export class PaymentFormComponent extends LoadingAndErrors implements OnInit {
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  host:string = LoopBackConfig.getPath();
  orders: {[key:string]: number} = {};
  order;
  data: PaymentForm = {
    paymentMethod: undefined
  };
  success: boolean = false;
  reference: string = undefined
  paymentTypes: typeof PAYMENT_TYPE = PAYMENT_TYPE;
  paymentMethods = PAYMENT_METHOD;
  state;
  payment;
  paymentMethod: number;
  allowPaypal = true;
  allowIPay88 = true;
  allowErrorMessage = '';
  allowPaynamics = true;

  payClicked = false;
  showCCCheck = false;
  hasCCPrefix = false;
  ccPrefix = new FormControl(''); 
  csrf = ''; 

  computedOrder$: Observable<Order> = this.ordersService.computed$; 
  cc$: Observable<CreditCard> =  this.ordersService.cc$;

  constructor(
    private route: ActivatedRoute,
    private loopBackAuth: LoopBackAuth,
    public productService: ProductsService,
    public discountService: DiscountsService,
    public orderingService: OrderingService,
    private orderApi: OrderApi,
    private toast: ToastrService,
    private paymentApi: PaymentApi,
    public modalService: BsModalService,
    private tokenExtractor: HttpXsrfTokenExtractor,

    private ordersService: OrdersService
  ) {
    super();
  }
  // @ViewChild('paypalRef') paypalRef: ElementRef;
  ngOnInit() {
    // var loadOrder = this.loadOrder.bind(this);
    this.route.paramMap.subscribe(this.loadOrder);
    // this.route.queryParams.subscribe(loadOrder);

    this.cc$.subscribe(value => 
      this.orderingService.isCredit = value && value.type ==='CREDIT'  
    );

    this.cc$.subscribe(value => {
      console.log('payment form cc$ subsbribe',value);
    })

    

    this.checkAllowedPayments();
    this.ccPrefix.valueChanges.subscribe(value => {
      if (value === 0 || (''+value).length === 6) {
        this.hasCCPrefix = true;
        this.ordersService.setCCPrefix(value);
      } else {
        this.hasCCPrefix =false;
        this.orderingService.isCredit = false;
      }
    });
    try {
      if (paypal) {
        paypal.Button.render({
          env: 'sandbox',
          commit: true,
          style: {
            label: 'paypal',
            // size:  'responsive',
            // shape: 'rect',
            color: 'gold',
            tagline: false
          },
          payment: this.paypalPaymentClick.bind(this),
          onAuthorize: this.paypalPaymentApproved.bind(this)
        }, '#paypal-button');
      }
    } catch (error) {

    }
    


  }
/*
  ngAfterViewInit() {
    
    if (this.paypalRef) {
        paypal.Buttons({           
          env: 'sandbox',
          commit: true,
          style: {
            layout: 'horizontal',
            label: 'paypal',
            size:  'responsive',
            shape: 'pill',
            color: 'gold',
            tagline: false
        } })
      .render(this.paypalRef.nativeElement);
    }  

  }

  createOrder(data, actions) {
    return actions.order.create({
        purchase_units: [{
            amount: {
                value: '0.01'
            }
        }]
    });
  }

  onApprove(data, actions) {
    return actions.order.capture();
  }
*/


  paynamicsClick(isOthers=false) {
    this.csrf = this.tokenExtractor.getToken();
    this.payClicked = true;
    
   const order = this.getOrderDetails(PAYMENT_METHOD.PAYNAMICS);
   let params =  { 
    order,
    orderId: this.state.params.id,
    ccPrefix: this.ccPrefix.value,
    isCredit: this.orderingService.isCredit,
    isOthers
    }
   return this.paymentApi.generatePaynamics(params)
    .subscribe(data => {
      const {host, b64string} = data;
      jQuery('#paymentrequest').val(b64string);
      jQuery('#paynamics-form').attr('action',host).submit();      
      
    })

  }
  cancelCCCheck() {
    this.showCCCheck = false;
    this.ccPrefix.setValue('');
  }

  loadOrder = (params) => {      
  // loadOrder(params) {      
    this.state = {...params};
    if (this.state.params && this.state.params.id) { 
      console.log('load order state params',this.state.params)
      const orderId = this.state.params.id;  
      this.loading.order = true;
      this.clearErrors();
      this.ordersService.findById(orderId);
      this.orderApi
        .findById(orderId, {
          include: 'orderItems'
        })
        .pipe(finalize(() => {
          this.loading.order = false;
        }))
        .subscribe((order: any) => {
          this.order = order;
          this.orders = (order.orderItems || [])
            .reduce((orders, order) => {
              orders[order.productType + order.planType] = order.quantity;
              return orders;
            }, {});
          this.data.paymentMethod = order.paymentMethod;
          if (order.status === 2) {
            this.success = true;
            this.paymentMethod = order.paymentMethod;
            this.reference = order.reference;
          }
        }, error => {
          this.errors.order = error.message || 'Unable to load Order details';
        });
    } else {
      this.orders = localStorage.getItem('orders') ? JSON.parse(localStorage.getItem('orders')) : {};
    }
  
}

  paypalPaymentClick() {
    this.clearErrors();
    return this.paymentApi
      .generatePaypal({
        order: this.getOrderDetails(PAYMENT_METHOD.PAYPAL),
        orderId: this.state.params.id       
      })
      .toPromise()
      .then(data => {
        this.payment = data;
        return data && data.id;
      })
      .catch(error => {
        this.errors.payment = error && error.message ||
          (this.state.params.id ? 'Failed to update payment.' : 'Failed to place order.');
      });
  }

  paypalPaymentApproved(data: paypalPaymentData) {
    this.clearErrors();
    return this.paymentApi
      .executePaypal({
        paymentId: data.paymentID,
        payerId: data.payerID,
        userId: this.getUser().id,
        order: this.getOrderDetails(PAYMENT_METHOD.PAYPAL),
        orderId: this.state.params.id
      })
      .toPromise()
      .then(response => {
        if (this.state.params.id) {
          this.toast.success('Order payment successfully updated', 'Update Order');
        } else {
          this.toast.success('Order successfully placed', 'Place Order');
          localStorage.setItem('orders', JSON.stringify({}));
        }
        this.success = true;
        this.paymentMethod = response.paymentMethod;
        this.reference = response.reference;
      })
      .catch(error => {
        this.errors.payment = error && error.message ||
          (this.state.params.id ? 'Failed to update payment.' : 'Failed to place order.');
      });
  }

  submit(form) {
    if (form.valid) {
      this.clearErrors();
      this.loading.payment = true;
      if (this.state.params.id) {
        this.loading.payment = false;
        this.success = true;
        this.reference = this.order.reference;
      } else {
        this.orderApi
          .create(this.getOrderDetails(PAYMENT_METHOD.BANK_TRANSFER))
          .pipe(finalize(() => {
            this.loading.payment = false;
          }))
          .subscribe((response: any) => {
            this.toast.success('Order successfully placed', 'Place Order');
            localStorage.setItem('orders', JSON.stringify({}));
            this.success = true;
            this.paymentMethod = response.paymentMethod;
            this.reference = response.reference;
          }, error => {
            this.errors.payment = error && error.message ||
              (this.state.params.id ? 'Failed to update payment.' : 'Failed to place order.');
          })
      }
    }
  }

  /**
   * IPay88 Click
   */
  ipay88Click() {
    this.clearErrors();
    this.loading.ipay88 = true;
    return this.paymentApi
    .generateIPay88({
      order: this.getOrderDetails(PAYMENT_METHOD.MAXICARE_PAYMENT),
      orderId: this.state.params.id
    })
    .toPromise()
    .then(payment => {
      this.payment = payment;

      const { MerchantCode, MerchantID, RefNo, MemberAccountID, Remark, UserContact,
        UserEmail, UserName, Amount, ProdDesc, Signature, ResponseURL } = payment.request;
      jQuery('#MerchantCode').val(MerchantCode);
      jQuery('#MerchantID').val(MerchantID);
      jQuery('#RefNo').val(RefNo);
      jQuery('#MemberAccountID').val(MemberAccountID);
      jQuery('#Remark').val(Remark);
      jQuery('#UserContact').val(UserContact);
      jQuery('#UserEmail').val(UserEmail);
      jQuery('#UserName').val(UserName);
      jQuery('#Amount').val(Amount);
      jQuery('#ProdDesc').val(ProdDesc);
      jQuery('#Signature').val(Signature);
      jQuery('#ResponseURL').val(ResponseURL);
      jQuery('#BackendURL').val(ResponseURL);

      jQuery('#ipay88form').submit((e) => {
        this.loading.ipay88 = false;
      });
      localStorage.setItem('orders', JSON.stringify({}));
      jQuery('#ipay88form').attr('action',payment.HOST).submit();
      /*
      return this.orderingService.makePayment(payment.HOST,payment.request).subscribe(result => {
        console.log(result);
      });
      */
      return payment && payment.id;
    })
    .catch(error => {
      this.errors.payment = error && error.message ||
        (this.state.params.id ? 'Failed to update payment.' : 'Failed to place order.');
    });

  }


  getOrderDetails(paymentMethod) {
    return {
      paymentMethod,
      items: this.orderingService
        .getProductOrders(this.orders)
        .map(product => {
          const quantity = this.orders[(product.productType || {}).name + product.planTypeCode];
          return {
            productType: (product.productType || {}).name,
            planType: (product || {}).planTypeCode,
            quantity: quantity,
          };
        })
    }
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  hasPaymentType(type) {
    if (!this.getUser()) {
      return false;
    }
    return (this.getUser().roles || [])
      .filter(role => {
        return role.paymentType === type;
      }).length > 0;
  }

  isMerchant() {
    const merchantRoles = this.getUser().roles


    const filteredRoles = merchantRoles.filter(role => role.role.description.indexOf('erchant') >= 0 );
    
    return filteredRoles.length > 0; 
  }


  checkAllowedPayments() {
    this.loading.checkAllowedPayments = true;
    var partnerId = this.getUser().partnerId;
    this.paymentApi.checkAllowedPayments(partnerId)
      .pipe(finalize(() => { this.loading.checkAllowedPayments = false; }))
      .subscribe(response => {
          response.allowed.map(item => {
            if (item.errorMessage) {

              switch(item.method) {
                case 'paypal': this.allowPaypal = false; break;
                case 'ipay88':
                  this.allowIPay88 = false;
                break;
                case 'paynamics':
                  this.allowPaynamics = false;
                  this.allowErrorMessage = item.errorMessage;
                  break;
              }
            }
          } )
        }
      )
  
  }
}
